import Button from '@/components/Buttons/Button';
import SingUpModal from '@/components/Modals/SingUpModal';
import { useAnalytics } from '@/services/analytics';
import { useAuth } from '@/services/auth';
import theme from '@/theme';
import { AppRoutes } from '@/utils/types';
import styled from '@emotion/styled';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import planes from '../../images/planes.png';

const Image = styled.div`
    display: flex;
    height: 174px;
    align-self: end;
`;

const Banner = styled.div`
    background-color: ${theme.colors.black[100]};
    border-radius: 12px;
    width: 100%;
    flex-shrink: 0;
    box-shadow:
        1.1px 2.7px 3.8px -1.2px rgba(187, 187, 187, 0.26),
        0.5px 1.3px 1.8px -0.6px rgba(187, 187, 187, 0.18),
        0.3px 0.8px 1.1px 0px rgba(187, 187, 187, 0.11);
`;

const Info = styled.div`
    padding: 32px;
`;

const Title = styled.div`
    font-weight: 700;
    letter-spacing: -0.56px;
    color: ${theme.colors.secondary[900]};
    font-size: 28px;
    margin-bottom: 24px;
`;

const ElementsContainer = styled.div`
    display: flex;
    height: 100%;
`;

export const FirstCampaignBanner = () => {
    const mixpanel = useAnalytics();
    const navigate = useNavigate();
    const { isAnonymous } = useAuth();
    const [showSignupModal, setShowSignupModal] = useState(false);

    const handleClick = () => {
        mixpanel?.track('campaigns-create', {
            event: 'click',
            from: 'banner-button',
        });

        if (isAnonymous) {
            setShowSignupModal(true);
            return;
        }

        navigate(AppRoutes.CampaignCreate);
    };

    return (
        <>
            {showSignupModal && (
                <SingUpModal
                    text="Sign up to create a campaign"
                    mainText="Create an account to start creating campaigns and unlock additional features."
                    from="translations"
                    isOpen
                    onClose={() => {
                        setShowSignupModal(false);
                    }}
                />
            )}
            <Banner>
                <ElementsContainer>
                    <Image>
                        <img src={planes} alt="Banner Image" />
                    </Image>
                    <Info>
                        <Title>Engage your audience</Title>
                        <Button
                            aria-valuetext="Create your first campaign"
                            color="secondary"
                            onClick={handleClick}
                            id="create-campaign-banner">
                            Create your first campaign
                        </Button>
                    </Info>
                </ElementsContainer>
            </Banner>
        </>
    );
};
